import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RegisterInput from '../components/RegisterInput';
import { asyncRegisterUser } from '../states/users/action';
import ImageOpening from '../image/image.png';

function RegisterPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onRegister = (registerPayload) => {
    dispatch(asyncRegisterUser(registerPayload));
    navigate('/');
  };

  return (
    <div className="register-page-wrapper">
      <section className="register-page">
        <header className="register-page__hero">
          <h1>Quantum</h1>
          <h2>A place to share knowledge and discuss some issues</h2>
        </header>
        <article className="register-page__main">
          <RegisterInput register={onRegister} />
        </article>
      </section>
      <div className="register-image">
        <img src={ImageOpening} aria-hidden alt="picture" />
      </div>
    </div>
  );
}

export default RegisterPage;
